'use client';

import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { getLocalizedPath } from '@packages/shared/src/utils/getLocalizedPath/getLocalizedPath';
import { defineMessages, useIntl } from 'react-intl';
import type { MessageTag } from 'react-intl';
import { Link } from '@packages/modules/src/Link/Link';

export const messages = defineMessages<{
  readonly standardAgb: { readonly conditions: MessageTag; readonly revocation: MessageTag };
}>({
  standardAgb: {
    id: 'BusinessTerms.LegalText',
    defaultMessage:
      'Es gelten die <conditions>Allgemeinen Geschäftsbedingungen</conditions> von Baur auch hinsichtlich des <revocation>Widerrufsrechts</revocation>.',
  },
});

/** Plain, non-interactive legal text with the AGB and revocation links. */
export const BusinessTermsText = () => {
  const {
    order: { externalUrls },
  } = useConfig();
  const { locale, formatMessage } = useIntl();

  return (
    <div className="text-size-body-xs">
      {formatMessage(messages.standardAgb, {
        conditions: (chunks: React.ReactNode) => (
          <Link
            key="conditions"
            href={getLocalizedPath(externalUrls.agb, locale)}
            className="text-color-text-darktransparent cursor-pointer underline"
            openInNewTab
          >
            {chunks}
          </Link>
        ),
        revocation: (chunks: React.ReactNode) => (
          <Link
            key="revocation"
            href={getLocalizedPath(externalUrls.revocation, locale)}
            className="text-color-text-darktransparent cursor-pointer underline"
            openInNewTab
          >
            {chunks}
          </Link>
        ),
      })}
    </div>
  );
};
